export interface AddNameTuneDto
{
    getMsisdn(): string;
    getToneId(): string;
    getToneName(): string;
    getLanguage(): string;
    getPackName(): string;
    getChannelId(): string;
    getUserName(): string;
}

export class AddNameTuneDtoImpl implements AddNameTuneDto
{
   
    private msisdn: string;
    private toneId: string;
    private toneName: string;
    private language: string;
    private packName: string;
    private channelId: string;
    private userName: string;

    setUserName(userName: string)
    {
        this.userName = userName;
    }
    getUserName(): string {
       return this.userName;
    }
    
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }
    getMsisdn(): string
    {
        return this.msisdn;
    }

    setToneId(toneId: string)
    {
        this.toneId = toneId;
    } 
    getToneId(): string 
    {
        return this.toneId;
    }

    setToneName(toneName: string)
    {
        this.toneName = toneName;
    } 
    getToneName(): string 
    {
        return this.toneName;
    }

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }  

    setPackName(packName: string)
    {
        this.packName = packName;
    }
    getPackName(): string 
    {
        return this.packName;
    }  
    
    setChannelId(channelId: string)
    {
        this.channelId = channelId;
    }
    getChannelId(): string 
    {
        return this.channelId;
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/addnametune/addnametunedto.ts